// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__23jCd","choiceBoxes":"toolbarselects_choiceBoxes__9O404","simpleField":"toolbarselects_simpleField__OLPUo"};